import FormattedMessage from 'I18n/components/FormattedMessage';
import { RouterLink } from '../../../components/AcademyLinks';
import HomePageSection from '../../../components/Layouts/HomePageSection';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { getSearchUrl } from '../../search/searchRouting';
import UsageTracker from '../../../utils/UsageTracker';
import { useInternalContentItems } from '../internalContentQueries';
import { GrowHomepageRecommendationsSection } from '../../recommendations/components/GrowHomepageRecommendations';
import { useHasGate } from '../../accounts/accountsQueries';
import { CardsSection } from '../../cardsSection';
import { NavMarker } from 'react-rhumb';
import { jsx as _jsx } from "react/jsx-runtime";
const PAGE_SIZE = 4;
const ViewAllLink = () => {
  const {
    isMobile
  } = useMediaQuery();
  const trackViewAllClick = () => UsageTracker.track('interaction', {
    action: 'internal-content-view-all-clicked'
  });
  return /*#__PURE__*/_jsx(RouterLink, {
    onClick: trackViewAllClick,
    to: getSearchUrl({
      contentSource: 'CUSTOM_CONTENT'
    }),
    underline: true,
    children: isMobile ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.internalContentSection.seeAll"
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.internalContentSection.viewAll"
    })
  });
};
const InternalContentSection = ({
  error,
  loading,
  items,
  totalCount
}) => {
  const {
    isLaptop
  } = useMediaQuery();
  const showViewMoreLink = totalCount > PAGE_SIZE;
  return /*#__PURE__*/_jsx(HomePageSection, {
    paddingBlock: "0",
    children: /*#__PURE__*/_jsx(CardsSection, {
      appearsIn: "internal-content-homepage",
      cardsContainerProps: {
        paddingBlockEnd: '0'
      },
      content: items,
      description: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.internalContentSection.description"
      }),
      direction: isLaptop ? 'column' : 'row',
      error: error,
      errorMarker: "HOMEPAGE_FEATURED_SECTION_ERROR",
      flush: true,
      header: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.internalContentSection.title"
      }),
      headerActions: showViewMoreLink ? /*#__PURE__*/_jsx(ViewAllLink, {}) : undefined,
      isLoading: loading,
      navMarker: "HOMEPAGE_FEATURED_SECTION_LOADED",
      size: isLaptop ? 'small' : 'large'
    })
  });
};
export const FeaturedSection = () => {
  const {
    hasGate: hasTrainerContentGate
  } = useHasGate('Academy:TrainerContent');
  const {
    internalContentItems,
    internalContentItemsLoading,
    internalContentItemsError,
    totalCount
  } = useInternalContentItems({
    pageLength: PAGE_SIZE,
    skip: !hasTrainerContentGate
  });
  if (hasTrainerContentGate) {
    if (!internalContentItemsLoading && !internalContentItemsError && (internalContentItems === null || internalContentItems === void 0 ? void 0 : internalContentItems.length) === 0) {
      return /*#__PURE__*/_jsx(NavMarker, {
        name: "HOMEPAGE_FEATURED_SECTION_LOADED"
      });
    }
    return /*#__PURE__*/_jsx(InternalContentSection, {
      error: internalContentItemsError,
      items: internalContentItems !== null && internalContentItems !== void 0 ? internalContentItems : [],
      loading: internalContentItemsLoading,
      totalCount: totalCount
    });
  }
  return /*#__PURE__*/_jsx(GrowHomepageRecommendationsSection, {});
};
export default FeaturedSection;